export class QuestionBase<T>{
  value: T;
  key: string;
  label: string;
  required: boolean;
  controlType: string;
  config: any;
  validator: any;

  constructor(options: {
      value?: T,
      key?: string,
      label?: string,
      required?: boolean,
      controlType?: string,
      config?: any,
      validator?: any
    } = {}) {
    this.value = options.value;
    this.key = options.key || '';
    this.label = options.label || '';
    this.required = !!options.required;
    this.controlType = options.controlType || '';
    this.config = options.config;
    this.validator = options.validator;
  }
}


// WEBPACK FOOTER //
// ./src/app/shared/components/form/models/question-base.model.ts